import CareerGuidance from './CareerGuidance.vue';

export default CareerGuidance;



// WEBPACK FOOTER //
// ./src/pages/profile/views/career-guidance/index.ts